export default "<app-jelly-box-loading *ngIf=\"loadingFlag\"></app-jelly-box-loading>\r\n<router-outlet></router-outlet>"